import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "py-3" }
const _hoisted_3 = { class: "container px-0 d-print-pagebreak" }
const _hoisted_4 = {
  "data-cy-id": "forecast-result-categories-scope3",
  class: "bg-alternative-green"
}
const _hoisted_5 = { style: {"padding":"20px"} }
const _hoisted_6 = { class: "py-4 row form-group" }
const _hoisted_7 = { class: "col-md-5 form-group" }
const _hoisted_8 = {
  id: "multiselect-scope3-categories-label",
  class: "form-label",
  for: "scope3-category-select"
}
const _hoisted_9 = { class: "col-md-5 form-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  id: "forecast-categories-result-chart"
}
const _hoisted_12 = {
  key: 1,
  class: "forecast-column-chart-placeholder"
}
const _hoisted_13 = { style: {"align-self":"center"} }
const _hoisted_14 = {
  class: "icon-svg",
  "aria-hidden": "true",
  style: {"display":"block","text-align":"center","margin":"auto"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#report-problem" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "forecast-column-chart-placeholder"
}
const _hoisted_18 = { style: {"align-self":"center"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  "aria-label": "Indlæser",
  class: "spinner"
}, null, -1)
const _hoisted_20 = {
  class: "spinner-status",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Scope3CategoryColumnChart = _resolveComponent("Scope3CategoryColumnChart")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, [
          _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.scope3-categories-chart.header' }, null, 8, ["text-key"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
            [_directive_dompurify_html, _ctx.resultCategorySummaryScope3]
          ])
        ])
      ]),
      _createElementVNode("form", {
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.formValidation.clearValidField && _ctx.formValidation.clearValidField(...args))),
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        onInvalidCapture: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formValidation.handleFormValidity && _ctx.formValidation.handleFormValidity(...args)), ["prevent"])),
        ref: "formGroup"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope3.field.category.name" })
            ]),
            _createVNode(_component_Multiselect, {
              id: "multiselect-scope3-categories",
              modelValue: _ctx.selectedCategories,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategories) = $event)),
              mode: "tags",
              "close-on-select": false,
              hideSelected: false,
              canClear: false,
              groups: true,
              "group-hide-empty": true,
              options: [
                               {
                                label: 'Alle opstrømskatagorier',
                                options: _ctx.possibleUpstreamCategories,
                                },
                                {
                                 label: 'Alle nedstrømskatagorier',
                                options: _ctx.possibleDownstreamCategories,
                                },
                            ],
              valueProp: "categoryId",
              label: "categoryPresentationName",
              ref: "forecast-category-select",
              class: "multiselect-calculation",
              aria: {'aria-labelledby': 'multiselect-scope3-categories-label', 'aria-placeholder': null, 'aria-multiselectable': null},
              placeholder: _ctx.getContentfulString('forecast.filter.placeholder.all-Categories-selected')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              id: "submit-scope3-filter",
              class: "button button-primary",
              style: {"margin-top":"8px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.refreshChart && this.refreshChart(...args))),
              disabled: _ctx.isPending
            }, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope123.button.submit.name" })
            ], 8, _hoisted_10)
          ])
        ])
      ], 544)
    ]),
    (_ctx.forecast.forcastHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("h4", null, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
          ]),
          (!_ctx.isLoadingPartially && !_ctx.isPending && !_ctx.hasFailed)
            ? (_openBlock(), _createBlock(_component_Scope3CategoryColumnChart, {
                key: 0,
                ref: "columnChart",
                "raw-data": _ctx.chartSettings,
                optimalColumnWidth: _ctx.AdjustedOptimalWidth
              }, null, 8, ["raw-data", "optimalColumnWidth"]))
            : (_ctx.hasFailed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16)),
                    _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.errorcalculatingforecast.message' }, null, 8, ["text-key"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_SimpleText, { "text-key": 'forecast.result.scope123.pendingload.chart' }, null, 8, ["text-key"])
                    ])
                  ])
                ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}